import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import logoImage from '../../assets/logo.png';
import { useApi } from 'context/ApiProvider';
import { showAlertDialog } from 'components/Dialog/dialog';
import { MuiTelInput } from 'mui-tel-input'


export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    password: "",
    username: "",
    name: "",
    phone: "",
    email: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const usernameRef = React.useRef<HTMLInputElement | null>(null);
  const phoneRef = React.useRef<HTMLInputElement | null>(null);
  const [error, setError] = useState<string | null>(null);
  const api = useApi();
  const USERNAME_REGEX = /^[a-zA-Z0-9.-]{3,20}$/;

  const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!form.username || !form.password || !form.name || !form.phone || !form.email) {
      setError('Please fill in all fields');
      return;
    }


    if (!USERNAME_REGEX.test(form.username)) {
      setError('Username must be 3–20 characters and can include letters, numbers, dash (-), and dot (.)');
      return;
    }

    if (!EMAIL_REGEX.test(form.email)) {
      setError("Invalid email address");
      return;
    }


    setIsLoading(true);
    setError('');

    try {
      const payload = {
        name: form.name,
        username: form.username,
        password: form.password,
        phone: form.phone,
        email: form.email,
      };

      const response = await api.post('/api/auth/register', payload);

      if (response.ok) {
        /*  setError(
           <span style={{ color: 'green', fontWeight: 'bold' }}>
             You have successfully signed up. Please contact t-soles.com to activate your account.
           </span>
         ); */
        const result = await showAlertDialog({
          title: "Registration Successful",
          description: "Please contact t-soles.com to activate your account.",
          agreeText: "Ok",
        });
        if (!result) return;
        navigate("/login");
      } else {
        setError(
          // <h2 style={{ color: 'red' }}>
          response?.body?.message ?? 'Sign up failed.'
          // </h2>
        );
      }
    } catch (err: any) {
      console.error('Sign up failed:', err);
      setError(err.response?.data?.message || 'Sign up failed.'
        // <h2 style={{ color: 'red' }}>
        //   {err.response?.data?.message || 'Sign up failed.'}
        // </h2>
      );
    } finally {
      setIsLoading(false);
    }
  };

  function validateUsername(username: string) {
    if (username.length < 3) {
      return "Username must be at least 3 characters long.";
    }

    if (username.length > 20) {
      return "Username cannot be longer than 20 characters.";
    }

    const invalidMatch = username.match(/[^a-zA-Z0-9.-]/);
    if (invalidMatch) {
      return `Username cannot include "${invalidMatch[0]}". Only letters, numbers, dash (-) and dot (.) are allowed.`;
    }

    return "";
  }

  function validatePhone(phone: string) {
    phone = phone.replace(/\s/g, ''); // remove spaces
    if (!/^\+\d+$/.test(phone)) {
      return "Phone number must contain digits only.";
    }

    if (!isValidE164(phone)) {
      return "Phone number is not valid. It should be in E.164 format, e.g. +1234567890.";
    }

    return "";
  }

  function isValidE164(phone: string): boolean {
    return /^\+[1-9]\d{7,14}$/.test(phone);
  }

  const handleUsernameBlur = () => {
    const err = validateUsername(form.username);

    if (usernameRef.current) {
      usernameRef.current.setCustomValidity(err);
      usernameRef.current.reportValidity();
    }
  };

  const handlePhoneBlur = () => {
  const err = validatePhone(form.phone);

  if (phoneRef.current) {
    phoneRef.current.setCustomValidity(err);
    phoneRef.current.reportValidity();
  }
};

  useEffect(() => {
    document.getElementById('username')?.focus();
  }, []);

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-logo">
          <img src={logoImage} alt="OpenCascade.js Logo" className="logo-image" />
        </div>
        {error && <h2 style={{ color: 'red' }}>{error}</h2>}
        {/* <h2>Sign up to continue...</h2> */}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">Choose your username</label>
            <input
              ref={usernameRef}
              className="login-input"
              type="text"
              id="username"
              name="username"
              placeholder="Username"
              value={form.username}
              onChange={(e) => {
                handleChange(e);
                if (usernameRef.current) usernameRef.current.setCustomValidity(""); // clear
              }}
              onBlur={handleUsernameBlur}
              required
              autoComplete="username"
              pattern="^[a-zA-Z0-9.-]{3,20}$"
            />

          </div>
          <div className="form-group">
            <label htmlFor="password">Choose your password</label>
            <input
              className="login-input"
              type="password"
              id="password"
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              required
              autoComplete="new-password"
            />
          </div>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              className="login-input"
              type="text"
              id="name"
              name="name"
              placeholder="Name"
              value={form.name}
              onChange={handleChange}
              required
              autoComplete="name"
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <MuiTelInput
              ref={phoneRef}
              className="login-input"
              id="phone"
              name="phone"
              placeholder="Mobile number"
              value={form.phone}
              onChange={(newValue) => {
                handleChange({
                  target: { name: "phone", value: newValue },
                } as React.ChangeEvent<HTMLInputElement>);
                if (phoneRef.current) phoneRef.current.setCustomValidity(""); // clear popup
              }}
              onBlur={handlePhoneBlur}
              required
              defaultCountry="NL"
              sx={{ 
                height: '44px',
                '& .MuiInputBase-root': { height: '100%' },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--input-border)' },
                '&:hover :not(.Mui-error) .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--input-border)' },
                '& .Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline': { 
                  borderColor: 'var(--input-border)',
                  borderWidth: '1px',
                },
              }}
              size="small"
              error={!form.phone || !!validatePhone(form.phone)}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              className="login-input"
              type="email"
              id="email"
              name="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
              required
              autoComplete="email"
            />
          </div>

          <button className="login-button" type="submit" disabled={isLoading}>
            {isLoading ? <span className="loading-spinner-small" /> : "Sign up"}
          </button>
        </form>
        <div className="signup-link-container" style={{ marginTop: "16px", textAlign: "center" }}>
          <span>Already have an account? </span>
          <span
            className="signup-link"
            onClick={() => navigate("/login")}
          >
            Login
          </span>
        </div>
      </div>
    </div>
  );
}